/**
 * Smooth scroll — Lenis, site-wide.
 *
 * Drives the whole-page scroll with Lenis for eased, momentum-based scrolling.
 * The instance is exposed on `window.lenis` so the overlay stores (menu, donate,
 * staff, directory) can pause smoothing while they lock the body — see
 * alpine-stores.js.
 *
 * Accessibility: no instance is created when the user prefers reduced motion,
 * and it tears down / rebuilds live if that preference changes at runtime.
 * Native scroll (and every existing `scroll` listener) keeps working either way.
 */

import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function create() {
  if (window.lenis) return;

  window.lenis = new Lenis({
    autoRaf: true, // Lenis owns its own requestAnimationFrame loop
    anchors: true, // eased scrolling for in-page #anchor links (header isn't sticky — no offset needed)
  });
}

function destroy() {
  if (!window.lenis) return;
  window.lenis.destroy();
  window.lenis = null;
}

function sync() {
  reduceMotion.matches ? destroy() : create();
}

sync();
reduceMotion.addEventListener('change', sync);
